import { Organization } from './organization';

/**
 * GET /api/v1/nca-parents/
 */
export const GET_NCA_PARENTS_PATH = 'nca-parents';
export type GetNcaParentsRequestPathVariables = undefined;
export type GetNcaParentsQueryParams =
  | {
      organization_id?: string;
    }
  | undefined;
export type GetNcaParentsSuccessDto = Organization[];
export type GetNcaParentsErrorDto = Error;
